// extracted by mini-css-extract-plugin
export default {"search":"styles_search__Upp6t","search-on":"styles_search-on__2sieN","icon":"styles_icon__PrzLz","input":"styles_input__i-Gpp","input-clear":"styles_input-clear__wLPVb"};